import Axios from 'axios';
import config from './config';

export default {
    /* 打开作品@米德 */
    detail (uuid) {
        const url = `${config.scratchApiRoot}/scratch/api/works/${uuid}`;
        // const url = `/scratch/api/works/${uuid}`;
        return Axios.get(url)
            .then(Axios.$success)
            .catch(Axios.$fail);
    },

    jsonData (dataUrl) {
        const url = `${config.scratchAssetRoot}${dataUrl}`;
        // const url = `${dataUrl}`;
        return Axios.create().get(url);
    },
    /**
     * 快照
     */
    snapshot(classUuid, classScheduleUuid) {
        const url = `${config.scratchAssetRoot}/snapshot/classSchedule/${classUuid}/${classScheduleUuid}.json`;
        return Axios.get(url).then(Axios.$success).catch(Axios.$fail);
    },
};
